import React from 'react';
import ProductCard from './ProductCard';
import { products } from '../data/content';

export default function Shop({ onAddToCart }) {
  return (
    <section id="shop" className="py-24 md:py-32 bg-[var(--off-white)]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row justify-between items-end mb-20 gap-8">
          <div className="max-w-2xl">
            <h2 className="text-4xl md:text-6xl font-bold text-[var(--navy)] mb-6 tracking-tight italic">Essential Systems</h2>
            <p className="text-gray-500 text-lg md:text-xl leading-relaxed">
              Carefully curated kits and refills designed to seamlessly integrate into your daily rhythms.
            </p>
          </div>
          <div className="flex gap-4">
            <button className="px-6 py-2 border-b-2 border-[var(--navy)] text-[var(--navy)] font-bold text-sm tracking-widest uppercase">All</button>
            <button className="px-6 py-2 border-b-2 border-transparent text-gray-400 hover:text-[var(--navy)] font-bold text-sm tracking-widest uppercase transition-colors">Kits</button>
            <button className="px-6 py-2 border-b-2 border-transparent text-gray-400 hover:text-[var(--navy)] font-bold text-sm tracking-widest uppercase transition-colors">Refills</button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-px bg-gray-100">
          {products.map(product => (
            <ProductCard key={product.id} product={product} onAdd={onAddToCart} />
          ))}
        </div>

        <div className="mt-20 p-12 bg-[var(--kraft-light)] rounded-2xl flex flex-col md:flex-row items-center justify-between gap-8 border border-[var(--kraft)]">
          <div className="text-center md:text-left">
            <h3 className="text-2xl md:text-3xl font-bold text-[var(--navy)] mb-2 italic">Building a Custom Workspace?</h3>
            <p className="text-gray-600">Bulk ordering available for commercial spaces and larger households.</p>
          </div>
          <button className="px-10 py-4 bg-[var(--navy)] text-[var(--mint)] font-bold uppercase tracking-[0.2em] text-xs hover:bg-[var(--navy-light)] transition-colors rounded-sm">
            Inquire Here
          </button>
        </div>
      </div>
    </section>
  );
}